export const FAQ_DATA = [
    {
        title: 'ONBOARDING',
        data: [
            {
                desc: 'How do I become a registered partner?',
                ansTitle: 'Registering as a partner on CARS24 to buy cars in auction can be via 3 easy steps:',
                note: 'Please note that membership is only allowed for professional used car dealers.',
                steps: [
                    {
                        title: 'Submit the relevant documents to your Relationship Manager',
                        subStep: [
                            {
                                subTitle: 'Documents/information to collected for corporate',
                                stepItems: [
                                    'Trade licence (Mandatory)',
                                    'VAT certificate (Mandatory)',
                                    'EID of owner (Front and back) (Mandatory)',
                                    'Passport copy (Mandatory)',
                                    'Visa copy (Mandatory)',
                                    'Driving licence (Good to have)',
                                    'Traffic file number (Dubai & Abudhabi) (Mandatory post signing)',
                                    'Bank details information (Mandatory)',
                                    'Singed dealer onboarding contract'
                                ]
                            },
                            {
                                subTitle: 'Documents to be collected for freelancer',
                                stepItems: [
                                    'EID of owner (Front and back) (Mandatory)',
                                    'Passport copy (Mandatory)',
                                    'Visa copy (Mandatory)',
                                    'Traffic file number (Dubai & Abudhabi)  (Mandatory post signing)',
                                    'Driving licence (Mandatory)',
                                    'Bank details information (Mandatory)',
                                    'Singed dealer onboarding contract'
                                ]
                            }
                        ]
                    },
                    {
                        title: 'Agreement Signing ',
                        subStep: [
                            {
                                subTitle: 'Cars24 to verify all documentation and get the contract signed',
                            },
                            {
                                subTitle: 'Create UserID & Password for channel partner will be created',
                            }
                        ]
                    },
                    {
                        title: 'Login with your credentials and start bidding',
                        subStep: [
                            {
                                subTitle: 'Login via sharing your registered mobile number and you shall receive the OTP for Instant login.',
                            }
                        ],
                    }
                ]
            },
            {
                desc: 'What are the privileges I receive post becoming a registered partner?',
                items: [
                    'You receive viewing access to our auction app',
                    'By submitting security deposit, you can start bidding as per allowed car won amount limits',
                    'Dedicated relationship manager'
                ]
            },
            {
                desc: 'Can someone become a partner without any registration?',
                items: [
                    'No'
                ]
            },
            {
                desc: 'What is the Security deposit that must be paid along with a registration?',
                ansTitle: 'A security deposit to be paid as following :',
                note: 'You can cancel membership at any time and get a refund of your deposit provided no penalties. Moreover, you can always top up your deposit to increase your ability to bid on and purchase more cars simultaneously.',
                items: [
                    'Each partner will pay 5000 AED to start with',
                    '5000 AED to allow each dealer to win 3 cars of 0-150K price segment'
                ]
            }
        ]
    },
    {
        title: 'PAYMENT',
        data: [
            {
                desc: 'How do I pay?',
                items: [
                    'Any of the following modes of payments are accepted- Cash deposits, Cheque, Bank transfer.',
                    'Our Relationship manager will share the ENBD & CBD accounts for any of the above deposits.'
                ]
            },
            {
                desc: 'What does it cost me to buy a car on CARS24 Auction process?',
                items: [
                    'CARS24 does not charge any fee to register on CARS24 auction process. However, if you decide to purchase a vehicle, you will have to pay the price of the vehicle along with Service fees of 1099 AED according to the car value which includes Transfer, Delivery and Processing fee.'
                ]
            },
            {
                desc: 'How much time do i get to make payment post winning a car?',
                items: [
                    'Payments have to be made within 18 hours of Car Won/Car procured by CARS24 to avoid penalties or cancellation charges'
                ]
            },
            {
                desc: 'What are the penalties If I am unable to do the payment (on time)?',
                items: [
                    '5% on invoice value will be charged due to late payment.'
                ]
            },
        ]
    },
    {
        title: 'BIDDING',
        data: [
            {
                desc: 'What is the Bidding process?',
                items: [
                    'Auctions run only for specific minutes & this may vary on each car. Bids can be placed after viewing a detailed inspection report. If you have placed the highest bid first, you will be awarded the deal provided the customer decided to sell this car at your bid.'
                ]
            },
            {
                desc: 'After what time will my bid expire?',
                items: [
                    'Bid is valid till 48 hours from bid submission;  Or till car gets transferred, if allocated to buyer.'
                ]
            },
            {
                desc: 'How can I cancel a bid or purchase?',
                items: [
                    'A bid or purchase is a binding contract. Once it has been placed, it cannot be lowered, cancelled or retracted.'
                ]
            },
            {
                desc: 'I am a registered partner however I am unable to bid on my car.',
                note: 'If you wish to increase your ability to bid on or purchase more cars simultaneously, we recommend to top up your deposit accordingly.',
                items: [
                    'Security deposit might be exhausted',
                    'There could be some outstanding amount pending from your previous purchase. Please clear your outstanding pendencies',
                    'Your deposit would be making your bid valid only on a few types of cars. Please connect with your RM',
                ]
            },
            {
                desc: 'What is the step up rate while bidding?',
                items: [
                    'Step up rate is the minimum amount by which you will be required to increase your bid.'
                ]
            },
            {
                desc: 'What does the green tick on the inspection report points mean?',
                items: [
                    'All checkpoints with Green Tick are re-verified for accuracy by Cars24.'
                ]
            },
        ]
    },
    {
        title: 'CAR REGISTRATION PROCESS',
        data: [
            {
                desc: 'What is the car Registration Process?',
                items: [
                    'Car registration will be handled by CARS24. No extra documents requirement from our CARS24 partners.'
                ]
            },
            {
                desc: 'What will be the registration charges?',
                items: [
                    'There are no additional charges as transfer is included in service. However, there are charges of 800 AED in case of Mulkiya to Mulkiya transfer.'
                ]
            }
        ]
    },
    {
        title: 'DELIVERY',
        data: [
            {
                desc: 'How soon can I expect delivery of my purchased car ?',
                ansTitle: 'Post payment completion & Loan clearance your car will be delivered to the comfort of your home',
                items: [
                    'If the car is not under loan then delivery will be done within 1-3 working days',
                    'If the car is under loan then delivery will be done within 2-3 weeks tentatively subject to loan closure.'
                ]
            },
            {
                desc: 'What are the car delivery Charges?',
                ansTitle: 'Car delivery charges are included in the AED 1099 service fee being charged for all emirates currently.',
                note: 'Partners can pick up the vehicle from MRL Hub also however the service fee shall still be applicable.'
            },
            {
                desc: 'If I am not able to pick the car on time what is the penalty I have ?',
                items: [
                    'You will be charged 50 AED/Day in case of any delay till delivery for MRL pick ups or basis & this will have to be paid at the time of delivery.'
                ]
            }
        ]
    },
    {
        title: 'SHIPPING',
        data: [
            {
                desc: 'Who is responsible for shipping the cars?',
                items: [
                    'CARS24'
                ]
            }
        ]
    },
    {
        title: 'INSPECTION',
        data: [
            {
                desc: 'Can I see the car physically before making the payment?',
                items: [
                    'No. The detailed inspection report will be the source for all car related description.'
                ]
            },
            {
                desc: 'Is the price of the vehicle negotiable?',
                items: [
                    'No. these prices are non-negotiable'
                ]
            },
            {
                desc: 'What if I find issues in the vehicle which are not mentioned on the inspection report?',
                items: [
                    'Car can be returned back within 24 hours from Time of Delivery against the guaranteed fields that will be marked on the inspection report at time of delivery. But the decision will be at the sole discretion of Cars24',
                    'For odometer or specification (GCC vs Non-GCC)  mismatch car can be returned in 15 hours.'
                ]
            }
        ]
    },
    {
        title: 'CHARGES'
    }
];